export default {
  props: {
    filter: Object,
    labels: Object,
    filterActive: Boolean,
    resetFilter: Function,
    productNumber: Number,
    mobileFilterVisible: Boolean,
  },
  methods: {
    closeMobileFilter() {
      this.$emit('close-mobile-filter');
    },
    getNumberOfActiveFilter(filterGroup) {
      let number = 0;
      Object.values(filterGroup).forEach((filterItem) => {
        number += filterItem.active ? 1 : 0;
      });
      return number;
    }
  },
  computed: {
    showProductsText() {
      return this.labels['showProducts'].replace('%s', this.productNumber);
    },
  },
  template: `
    <div class="col-xl-3">
      <div class="z-index-2000 sticky-top mb-1 mb-xl-2">
        <div class="filter pe-xxl-1" :class="{'active': mobileFilterVisible}" id="filter">
          <div class="filter-header d-flex justify-content-between p-1 px-xl-0">
            <h5 class="d-flex align-items-center m-0"><i class="las la-sliders-h me-50"></i> {{ labels.filter }}</h5>
            <button @click.prevent="closeMobileFilter" class="btn btn-transparent btn-toggle-filter me-n25 d-xl-none"><i class="las la-times"></i></button>
          </div>

          <div class="accordion accordion-filter" id="accordionFilter">
            <div v-for="(filterGroup, index) in filter" class="accordion-item">
              <h4 class="accordion-header" :id="'heading' + index">
                <button class="accordion-button collapsed m-0 fw-bolder fs-sm" type="button" data-bs-toggle="collapse" :data-bs-target="'#collapse' + index" aria-expanded="false" :aria-controls="'collapse' + index">{{ labels[index] }} <span v-if="getNumberOfActiveFilter(filterGroup) > 0" class="rounded px-50 small py-15 text-muted bg-light ms-50  ">{{ getNumberOfActiveFilter(filterGroup) }}</span></button>
              </h4>
              <div :id="'collapse' + index" class="accordion-collapse collapse" :aria-labelledby="'heading' + index" data-bs-parent="#accordionFilter">
                <div class="accordion-body pt-25">
                  <ul class="list-unstyled d-flex flex-wrap m-0">
                    <li v-for="(filterItem, indexItem) in filterGroup" class="form-btn-check me-75 mb-75">
                      <input v-model="filterItem.active" class="form-check-input d-none" type="checkbox" value="" :id="'flexCheck' + index + indexItem">
                      <label class="form-check-label btn-check-label" :for="'flexCheck' + index + indexItem">{{ filterItem.label }}</label>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="filter-footer p-2 pb-1 px-xl-0 py-xl-1 text-center text-xl-start">
            <button @click.prevent="closeMobileFilter" class="btn btn-primary w-100 d-xl-none mb-1">{{ showProductsText }}</button>
            <button @click.prevent="resetFilter" class="text-primary btn-transparent fs-sm" :class="{'opacity-25': !filterActive}" href="#">{{ labels.resetFilter }}</button>
          </div>
        </div>
      </div>
    </div>
  `
}
